"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
function charToRegex(x) {
    switch (x) {
        case "digito":
            return /\d/;
        case "letra":
            return /[A-Z,a-z]/;
        case "alphanum":
            return /[A-Z,a-z,\d]/;
        default:
            return keautils_1.assertUnreachable(x);
    }
}
function applyCharTransform(text, trans) {
    switch (trans) {
        case "upper":
            return text.toUpperCase();
        case "lower":
            return text.toLowerCase();
        case undefined:
            return text;
        default:
            return keautils_1.assertUnreachable(trans);
    }
}
/**Convierte un TextMask a uno compatibla con el MaskedInput */
function textMaskToMaskedInputMask(mask) {
    let ret = [];
    for (const m of mask) {
        if (typeof (m) == "string") {
            ret.push(m);
        }
        else {
            ret.push(...keautils_1.range(0, m.count).map(x => charToRegex(m.char)));
        }
    }
    return ret;
}
exports.textMaskToMaskedInputMask = textMaskToMaskedInputMask;
function pipeFunc(mask) {
    return function pipe(input) {
        let ret = "";
        let start = 0;
        for (const m of mask) {
            if (typeof (m) == "string") {
                ret += m;
                start += m.length;
            }
            else {
                ret += applyCharTransform(input.substring(start, start + m.count), m.trans);
                start += m.count;
            }
        }
        return ret;
    };
}
exports.pipeFunc = pipeFunc;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/mask/logic.js
// module id = 2210
// module chunks = 0